// Technology portfolio content, shared with the Technology page.
export const technologies = [
  {
    number: "01",
    label: "Biomass Pyrolysis",
    title: "24 TPD Biomass Pyrolysis",
    body:
      "Designed and operated by a team that ran this technology themselves before offering it for sale.",
    href: "/equipment#pyrolysis",
  },
  {
    number: "02",
    label: "Torrefaction",
    title: "Biomass Torrefaction",
    body:
      "Torrefaction is mild pyrolysis \u2014 biomass is heated in a low-oxygen environment to around 200\u2013300\u00B0C, just enough to drive off moisture and volatiles without fully carbonizing the material.",
    href: "/equipment#torrefaction-plant",
  },
  {
    number: "03",
    label: "CBG",
    title: "Modular CBG System",
    body:
      "Compressed Biogas (CBG) is renewable methane produced by upgrading biogas from organic waste. Built on proven, licensed technology, our 50\u20131,000 kg/day skid-based systems enable distributed production close to the feedstock source, with modular capacity and simpler deployment.",
    href: "/equipment",
  },
  {
    number: "04",
    label: "Convergent",
    title: "Carbon MRV Platform",
    body:
      "Convergent is Tanren's monitoring, reporting, and verification platform for carbon removal projects \u2014 starting with biochar.",
    href: "/mrv",
  },
];

export const proofPoints = ["Designed", "Built", "Operated"];

export const metrics = [
  { value: "40+", label: "combined founder-years" },
  { value: "4", label: "plants installed/commissioned" },
  { value: "5,000+", label: "tCO2e removal capacity enabled" },
  { value: "3,000+", label: "t biochar sold" },
];
